module.exports = __webpack_public_path__ + "media/images/front/sp/error/img_404-f3b058c53c9a825a550d8f5136bf21bf.png";